import { useEffect, useState } from 'react';
import { t } from '@lingui/macro';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { useFormQueryService } from '../../../services/FormQueryService';

const useStyles = makeStyles((theme) => ({
    autoComplete: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
}));

const cityApiUrl = '/ipm/v1/admin/geoCoordinates/';
const cityRequestParams = {
    entityFields: ['city'],
    rowLimit: 10000,
    rowStart: 0,
};

const id = 'siteLocationPicker';
const noOptionsText = t`Search for a city, or click the map to set a location`;
const placeholderText = t`Search for a City`;

export function SiteAdminLocationField(fieldProps) {
    const classes = useStyles();
    const { setSearchLocation, searchLocation, defaultSearchText, siteLongitude, siteLatitude } = fieldProps;
    const [options, setOptions] = useState([]);
    const formQueryService = useFormQueryService();

    const handleCitySearchChange = (event, search) => {
        if (_.isEmpty(search)) {
            return setOptions([]);
        }

        return formQueryService
            .queryAPI(cityApiUrl, {}, _.extend({}, cityRequestParams, { search }))
            .then((queryResponse) => {
                const isExactCityMatch = (item) => _.isEqual(_.lowerCase(search), _.lowerCase(item.city));

                // Partition into exact and partial matches...
                const [exactMatches, partialMatches] = _.partition(queryResponse.data, isExactCityMatch);

                // ...and re-merge the partitions. This ensure exact matches bubble up to the top.
                setOptions([...exactMatches, ...partialMatches]);
            });
    };

    const loadScreen = () => {
        if (siteLatitude && siteLongitude) {
            return setSearchLocation({
                city: '',
                latitude: siteLatitude,
                longitude: siteLongitude,
            });
        }

        if (_.isEmpty(searchLocation)) {
            setSearchLocation({ city: defaultSearchText });
        }
    };

    useEffect(() => {
        loadScreen();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteLatitude, siteLongitude, defaultSearchText]);

    return (
        <div className={classes.autoComplete}>
            <Autocomplete
                onChange={(event, newValue) => {
                    setSearchLocation(newValue);
                }}
                value={searchLocation}
                size="small"
                fullWidth
                onInputChange={_.debounce(handleCitySearchChange, 250)}
                id={id}
                options={options}
                getOptionLabel={(option) => {
                    return `${option.city}${option.province ? `, ${option.province}` : ''}${
                        option.country ? `, ${option.country}` : ''
                    }`;
                }}
                noOptionsText={noOptionsText}
                renderInput={(params) => <TextField {...params} placeholder={placeholderText} variant="outlined" />}
            />
        </div>
    );
}
